module.exports = __webpack_public_path__ + "static/gps-7267783e3559c6f7c7a97665d9a1853c.png";